export const ITEM_TYPE = Object.freeze({
    PROJECT: 'PROJECT',
    TEMPLATE: 'TEMPLATE',
});

export const EDITOR_TYPE = ITEM_TYPE;
